export const SET_EMENTA_ID_CONCLUIDA = 'SET_EMENTA_ID_CONCLUIDA'
